import React from 'react'
import Link from 'gatsby-link'

export default class FaqCallout extends React.Component {
  render() {
    const { trip } = this.props

    return (
      <div className="faq-callout">
        <div className="wrap">
          <h2>Any questions?</h2>
          <Link className="btn btn-rounded" to={`/${trip}/faq/`}>
            Check out our FAQ’s
            <i className="fa fa-external-link" />
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/faq-callout.js